import React from "react";
import {
  Box,
  Container,
  LinearProgress,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { Seo } from "src/components/seo";
import SetupGuide from "./infocards/SetupGuide";
import { useAuth } from "src/hooks/use-auth";

const PleaseWait: React.FC = () => {
  const { user, dispatch } = useAuth();
  console.log("test", user);

  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <Seo title="Building your Nightscout" />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
            pb: "120px",
            height: mdUp ? undefined : "auto",
            flexGrow: 1,
            py: 12,
          }}
        >
          <Container maxWidth="md">
            <Stack
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                pb: 5,
                mx: 2,
              }}
              spacing={2}
            >
              <HourglassEmptyIcon
                sx={{ fontSize: 60, color: theme.palette.primary.main }}
              />
              <LinearProgress sx={{ width: "100%", mt: 3 }} />
              <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  color: theme.palette.primary.main,
                  pb: 4,
                }}
              >
                {"Building your Nightscout"}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  textAlign: "center",
                  color: theme.palette.text.secondary,
                }}
              >
                {
                  "You'll receive an email with your Nightscout URL once it's ready. After receiving the email, you can access your Nightscout by clicking the link in the email or logging in."
                }
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 2,
                  textAlign: "center",
                  color: theme.palette.text.secondary,
                }}
              >
                {
                  "If you have any questions or need help, please don't hesitate to reach out to us via "
                }{" "}
                <Link
                  href="https://wa.me/31639202608"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {"WhatsApp"}
                </Link>{" "}
                {"or"}{" "}
                <Link
                  href="mailto: info@opensource.clinic"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {"Email"}
                </Link>
                .
              </Typography>
            </Stack>
            <SetupGuide />
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default PleaseWait;
